import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {ErrorsObject} from '../../../shared/utilities/error-utility.utility';
import * as fromModuleModels from '../../models';
import {FormsService} from '../../../shared/services';

@Component({
  selector: 'discount-form',
  styleUrls: ['discount-form.component.scss'],
  template: `

    <div class="card mat-elevation-z1">

      <div class="card__heading">
        <span>{{ presets$.getValue() ? 'Rabattstufe bearbeiten' : 'Neuen Rabattstufe anlegen' }}</span>
      </div>

      <div class="card__content p-a--24" [formGroup]="df">

        <div class="grid">
          <div class="column-9">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input type="text" matInput formControlName="name" required>
              <mat-hint align="start" *ngIf="errors?.name">{{ errors.name.message }}</mat-hint>
            </mat-form-field>
          </div>

          <div class="column-5">
            <mat-form-field>
              <mat-label>Rabatt</mat-label>
              <input type="text" matInput formControlName="value" required>
              <span matPrefix>%&nbsp;</span>
              <mat-hint align="start" *ngIf="errors?.value">{{ errors.value.message }}</mat-hint>
            </mat-form-field>
          </div>

          <div class="m-ta--2 column-14">

            <button *ngIf="presets$.getValue() || df.dirty" class="m-r--16" (click)="cancelEdit()" type="button"
                    color="outline" mat-flat-button>
              <mat-icon class="m-r--8">cancel</mat-icon>
              <span>Abbrechen</span>
            </button>

            <button [disabled]="df.invalid || df.untouched" (click)="handleSubmit()" mat-flat-button color="green">
              <mat-icon class="m-r--8">save</mat-icon>
              <span>{{ presets$.getValue() ? 'Aktualisieren' : 'Anlegen' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--<pre>{{ errors | json }}</pre>-->
  `
})
export class DiscountFormComponent implements OnInit {

  @Input() errors: ErrorsObject;
  @Input() presets$: BehaviorSubject<any>;

  @Output() requestCreateItem: EventEmitter<{
    payload: fromModuleModels.Discount,
    entity: string
  }> = new EventEmitter();
  @Output() requestUpdateItem: EventEmitter<{
    iri: string,
    payload: fromModuleModels.Discount,
    entity: string
  }> = new EventEmitter();

  df: FormGroup;
  onDestroy$: Subject<any> = new Subject<any>();

  constructor(private fb: FormBuilder, private fs: FormsService) {
  }

  ngOnInit(): void {
    this.presets$.pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(preset => {
      this.initForm();
      this.fs.patchForm(this.df, preset);
      this.df.markAsUntouched();
    });
  }

  initForm() {
    this.df = this.fb.group({
      name: this.fb.control(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      value: this.fb.control(null, [Validators.required, Validators.min(1), Validators.max(100)])
    });
  }

  cancelEdit() {
    this.initForm();
    this.presets$.next(null);
  }

  handleSubmit(): void {

    const payload: fromModuleModels.Discount = this.df.value;

    !this.presets$.getValue()
      ? this.requestCreateItem.emit({payload, entity: 'Discount'})
      : this.requestUpdateItem.emit({iri: this.presets$.getValue()['@id'], payload, entity: 'Discount'});
  }
}
